<script setup>
import { useUIStore } from "@/stores/ui";
import AppSidebar from "./AppSidebar.vue";
import PendingChangesBar from "./PendingChangesBar.vue";
import BaseIcon from "@/components/ui/BaseIcon.vue";

const ui = useUIStore();
</script>

<template>
  <div class="h-screen overflow-hidden bg-slate-50">
    <AppSidebar />

    <!-- Floating menu button (mobile only). The top app bar is gone, so this is
         how the sidebar is opened on small screens. Hidden on lg+. -->
    <button
      class="lg:hidden fixed top-3 left-3 z-30 flex items-center justify-center w-10 h-10 rounded-lg bg-white/90 backdrop-blur border border-slate-200 shadow-sm text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors"
      aria-label="開啟選單"
      @click="ui.toggleMobileSidebar"
    >
      <BaseIcon name="menu" class="w-5 h-5" />
    </button>

    <div :class="['h-screen flex flex-col transition-all duration-300 ease-smooth', ui.sidebarCollapsed ? 'lg:ml-[72px]' : 'lg:ml-[260px]']">
      <!-- Page-wide「尚未發佈」bar: saved-but-not-deployed count + 發佈更新 + status -->
      <PendingChangesBar />

      <main class="flex-1 overflow-y-auto overflow-x-clip px-4 sm:px-6 lg:px-8 pb-4 sm:pb-6 lg:pb-8 pt-16 lg:pt-8">
        <RouterView v-slot="{ Component, route }">
          <Transition
            enter-active-class="transition duration-300 ease-smooth" enter-from-class="opacity-0 translate-y-2"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition duration-200 ease-smooth" leave-from-class="opacity-100" leave-to-class="opacity-0 -translate-y-2"
            mode="out-in"
          >
            <component :is="Component" :key="route.path" />
          </Transition>
        </RouterView>
      </main>
    </div>

    <Transition
      enter-active-class="transition duration-300 ease-out" enter-from-class="opacity-0" enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in" leave-from-class="opacity-100" leave-to-class="opacity-0"
    >
      <div v-if="ui.sidebarMobileOpen" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 lg:hidden" @click="ui.closeMobileSidebar" />
    </Transition>
  </div>
</template>
